const fineartsCoordinatorData = [
    {
      name: "Deepak Verma",
      contact: "+91 8750562418",
      // course: "B.Tech ME",
      image:'Deepak'
    },
    {
      name: "Neha Sharma",
      contact: "+91 9319922616",
      // course: "B.Tech CSE",
      image:'Neha'
    },
    
    
  ];
  export default fineartsCoordinatorData;